module.exports = __webpack_public_path__ + "img/89.b452b573.jpg";